import { useEffect, useMemo, useState } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import DonutChart from "react-donut-chart";
import "../styles/Dashboard.css";
// import Listings from "./Listings";
import Tickets from "./Tickets";

function Dashboard() {
  const ratingsData = useMemo(() => {
    return [
      { star5: 10, star4: 5, star3: 7, star2: 12, star1: 4 },
      { star5: 20, star4: 13, star3: 4, star2: 5, star1: 9 },
    ];
  }, []);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  function handleRange(item) {
    setRange([item.selection]);
  }
  useEffect(() => {
    document.addEventListener("mouseup", function (e) {
      var container = document.querySelector(".date-range-picker");
      if (container && !container?.contains(e.target)) {
        container.classList.add("d-none");
      }
    });
  }, []);
  return (
    <div className="dashboard">
      <div className="header-container">
        <div className="logo">
          <NavLink to="/">
            <img src="/images/logo.png" alt="LogoImage" />
          </NavLink>
        </div>
        <div className="header-wrapper">
          <div className="header1">
            <span>
              <i className="fa-solid fa-arrow-left-long"></i>ITSM
            </span>
            <h3>Dashboard</h3>
          </div>
          <div className="header2">
            <img src="/images/user1.png" alt="AdminImage" />
          </div>
        </div>
      </div>
      <div className="row m-0 nav-container">
        <div className="col-md-2 nav-wrapper">
          <ul>
            <li>
              <NavLink
                to=""
                className={() =>
                  window.location.pathname === "/dashboard" ? "active" : ""
                }
              >
                <i className="fa-solid fa-clone"></i> IT Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink to="tickets">
                <i className="fa-solid fa-list"></i> IT Ticket
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="col-md-10 it-dashbord">
          <Routes>
            <Route
              path="/"
              element={
                <div className="dashboard-container">
                  <p>
                    <span>IT Desk</span>
                  </p>
                  <div className="dashboard-wrapper">
                    <div className="date-container">
                      <h4>
                        Top Requests -
                        <span>{format(range[0]?.startDate, "dd/MM/yyyy")}</span>{" "}
                        and
                        <span>{format(range[0]?.endDate, "dd/MM/yyyy")}</span>
                      </h4>
                      <div className="date-range-container">
                        <div
                          className="date-range-btn"
                          role="button"
                          onClick={() => {
                            document
                              .querySelector(".date-range-picker")
                              .classList.remove("d-none");
                          }}
                        >
                          <button>
                            <span>From</span>
                            {format(range[0]?.startDate, "LLL dd, yyyy")}
                          </button>
                          <button>
                            <span>To</span>
                            {format(range[0]?.startDate, "LLL dd, yyyy")}
                          </button>
                        </div>
                        <DateRangePicker
                          className="date-range-picker d-none"
                          onChange={(item) => handleRange(item)}
                          showSelectionPreview={true}
                          moveRangeOnFirstSelection={false}
                          months={2}
                          ranges={range}
                          direction="vertical"
                        />
                      </div>
                    </div>
                    <div className="row m-0 chart-container">
                      <div className="col-md-4 chart-categories">
                        <h5>Top 5 Request Categories</h5>
                        <div className="chart">
                          <DonutChart
                            colors={[
                              "#f7941d",
                              "#a0a0cb",
                              "#8a88ed",
                              "#0db53c",
                              "#607d8b",
                            ]}
                            data={[
                              {
                                label: "Give you up",
                                value: 25,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 15,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 chart-categories">
                        <h5>Top 5 Request Categories</h5>
                        <div className="chart">
                          <DonutChart
                            colors={[
                              "#ffc107",
                              "#5bc4bf",
                              "#de64a1",
                              "#fb7158",
                              "#77a2c7",
                            ]}
                            data={[
                              {
                                label: "Give you up",
                                value: 25,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 15,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 chart-categories">
                        <h5>Top 5 Request Categories</h5>
                        <div className="chart">
                          <DonutChart
                            colors={[
                              "#da5db6",
                              "#77a2c7",
                              "#f7941d",
                              "#0db53c",
                              "#5bc4bf",
                            ]}
                            data={[
                              {
                                label: "Give you up",
                                value: 25,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 15,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 chart-categories pt-5">
                        <h5>Top 5 Request Categories</h5>
                        <div className="chart">
                          <DonutChart
                            colors={[
                              "#b69fb3",
                              "#a0a0cb",
                              "#8a88ed",
                              "#0db53c",
                              "#607d8b",
                            ]}
                            data={[
                              {
                                label: "Give you up",
                                value: 25,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                              {
                                label: "",
                                value: 15,
                              },
                              {
                                label: "",
                                value: 20,
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-md-8 rating-container">
                        <h6>Overall Ratings</h6>
                        <div className="row m-0">
                          <div className="col-md-6 rating-page pe-4">
                            <div className="rating-text">
                              <span>Final Ops Rating</span>
                              <span>
                                Overall Rating:{" "}
                                {ratingsData[0].star5 +
                                  ratingsData[0].star4 +
                                  ratingsData[0].star3 +
                                  ratingsData[0].star2 +
                                  ratingsData[0].star1}
                              </span>
                            </div>
                            <div className="ratings-star">
                              <p>5 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star5}</span>
                            </div>
                            <div className="ratings-star">
                              <p>4 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star4}</span>
                            </div>
                            <div className="ratings-star">
                              <p>3 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star3}</span>
                            </div>
                            <div className="ratings-star">
                              <p>2 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star2}</span>
                            </div>
                            <div className="ratings-star">
                              <p>1 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star1}</span>
                            </div>
                          </div>
                          <div className="col-md-6 rating-page ps-4">
                            <div className="rating-text">
                              <span>Final Ops Rating</span>
                              <span>Overall Rating:{25}</span>
                            </div>
                            <div className="ratings-star">
                              <p>5 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                {/* <i className="fa-regular fa-star"></i> */}
                              </div>
                              <hr />
                              <span>{ratingsData[0].star5}</span>
                            </div>
                            <div className="ratings-star">
                              <p>4 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star4}</span>
                            </div>
                            <div className="ratings-star">
                              <p>3 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star3}</span>
                            </div>
                            <div className="ratings-star">
                              <p>2 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star2}</span>
                            </div>
                            <div className="ratings-star">
                              <p>1 Start</p>
                              <div>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                                <i className="fa-regular fa-star"></i>
                              </div>
                              <hr />
                              <span>{ratingsData[0].star1}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
            <Route path="/tickets" element={<Tickets />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
export default Dashboard;
